export default __webpack_public_path__ + "media/images/images/carousel/27-27b6903ba45761f904eda734baadf8b9.jpg";